import { useTranslation } from 'next-i18next';

const Title = ({ title }) => {
  const { t } = useTranslation();

  return (
    <h1
      id="title_page"
      style={{ margin: '0 auto', fontSize: '30px' }}
      className="text-capitalize text-info text-center">
      <span dangerouslySetInnerHTML={{ __html: t([title]) }} />
    </h1>
  )
}

export default Title;
